// extracted by mini-css-extract-plugin
export var centerText = "_5x-8";
export var container = "_5x-0";
export var doughnutContainer = "_5x-7";
export var legend = "_5x-a";
export var legendItemColorDisplay = "_5x-b";
export var legendItemLabel = "_5x-d";
export var legendItemValue = "_5x-c";
export var lg = "_5x-5";
export var maxWidth = "_5x-9";
export var md = "_5x-4";
export var responsive = "_5x-6";
export var sm = "_5x-3";
export var xs = "_5x-2";
export var xxs = "_5x-1";